import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../../../../components/Button';
import CardDocument from '../../../../components/Cards/Document';
import FileViewer from '../../../../components/FileViewer';
import Modal from '../../../../components/Modal';
import StepProgress from '../../../../components/StepProgress';
import { useGlobal } from '../../../../contexts/Global/context';
import { useSolicitacaoGuias } from '../../../../contexts/SolicitacaoGuias/context';
import { enviarDocumentosSolicitacaoGuias } from '../../../../services/registroAcidentados/solicitacaoGuias';
import { ButtonSection, ContainerButton, PageContainer } from '../../../../styles/styles';
import { addTimeToNameFile, base64toBlob, checkIsSupport, cloneObject, handleTopCritics } from '../../../../utils';
import regexps from '../../../../utils/regexps';
import steps from '../../../../utils/steps.json';
import Alertas from '../Alertas';
import dataDocs from './data';
import * as S from './styles';

/* eslint-disable arrow-body-style */

function Documentos() {
    const history = useHistory();

    const [showModal, setShowModal] = useState(false);
    const [modalInfo, setModalInfo] = useState({});
    const [loadingPost, setLoadingPost] = useState(false);
    const { setShowSupportModal } = useGlobal();

    const { dataDocuments, setDataDocuments, dataSolicitacaoGuias, setDataNumReferencia, setAlerts } =
        useSolicitacaoGuias();

    useEffect(() => {
        setDataDocuments([...dataDocuments]);
    }, []);

    function handleFileChange({ event, id }) {
        if (!event.target.files) return;

        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
            const { name: fileName, size: fileSize, type: fileType } = file;

            const fileNameFiltered = fileName.replace(regexps.charRemove, '');

            const base64 = reader.result.split(',')[1];

            event.target.value = null;

            const acceptedFormats = ['jpeg', 'jpg', 'png', 'pdf', 'svg'];

            const fileExtension = fileNameFiltered.substring(fileNameFiltered.lastIndexOf('.') + 1);
            if (!acceptedFormats.includes(fileExtension.toLowerCase())) return;

            const fileSizeKb = fileSize / 1024;

            if (fileSizeKb > 25000) {
                const modalContent = 'Somente é permitido anexar documentos com tamanho inferior a 25000KB (25MB).';
                setModalInfo({
                    title: 'Erro',
                    content: <p>{modalContent}</p>,
                    backButton: true,
                });
                setShowModal(true);
                return;
            }

            const dataDocument = {
                id,
                base64,
                name: addTimeToNameFile(fileNameFiltered, fileExtension),
                type: fileType,
                size: `${fileSizeKb.toFixed(2)}Kb`,
            };

            const documents = cloneObject(dataDocuments);

            const foundDocument = documents.filter(
                (document) => document.id === id && document.name === fileNameFiltered
            );

            if (foundDocument.lenght) return;

            documents.push(dataDocument);

            setDataDocuments([...documents]);
        };

        reader.readAsDataURL(file);
    }

    function handleFileDelete({ fileName }) {
        let documents = cloneObject(dataDocuments);

        documents = documents.filter((document) => document.name !== fileName);

        setDataDocuments(documents);
    }

    function handleShowModal(file) {
        const extArquivo = file.name.split('.')[1];

        const mode = ['jpeg', 'jpg', 'png', 'svg'].includes(extArquivo.toLowerCase()) ? 'image' : 'application';

        const blob = base64toBlob(file.base64, `${mode}/${extArquivo}`);

        const blobUrl = URL.createObjectURL(blob);

        setModalInfo({
            title: file.name,
            content: <FileViewer fileExtension={extArquivo} src={blobUrl} base64={file.base64} />,
        });
        setShowModal(true);
    }

    function disableBtn() {
        // eslint-disable-next-line arrow-body-style
        const docsSolicitacaoGuia = dataDocs.filter((element) => element.category === 'solicitacaoGuiaUpload').map((element, index) => ({
            id: element.documents[index].id
        }));
        const disable = docsSolicitacaoGuia.map((docId) => {
            return dataDocuments.some((elem) => elem.id === docId.id);
        });

        return disable.some((elem) => elem === false);
    }

    async function handleFowardStep() {
        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        setLoadingPost(true);

        const payloadDocument = dataDocuments.flat().map((doc) => ({
            nome: doc.name,
            arquivo: doc.base64,
            contentType: doc.type,
        }));

        const payload = {
            ...dataSolicitacaoGuias,
            arquivos: payloadDocument,
        };

        const response = await enviarDocumentosSolicitacaoGuias(payload);

        if (response?.retorno?.codigo !== '0') {
            response.retorno = [
                {
                    criticas: [
                        {
                            tipo: 1,
                            mensagem: response?.data?.message,
                            codigo: '#DEFAULT_ERROR',
                        },
                    ],
                },
            ];
        }

        const numeroReferencia = response.numeroReferenciaProcessamento;
        const criticas = handleTopCritics(response?.data?.message);

        setDataNumReferencia(numeroReferencia);

        if (criticas.length > 0) {
            setAlerts([...criticas]);

            setTimeout(() => {
                window.document.getElementById('page-content').scrollTo(0, 0);
            }, 100);
            return;
        }

        history.push('/dados_beneficiario/validar_solicitacao_guias');
    }

    return (
        <PageContainer>
            <StepProgress steps={steps.solicitacaoGuias} activeStep={3} />

            <Alertas />

            <S.PageTitle>
                Agora, faça o upload dos documentos necessários para autorização do procedimento.{' '}
            </S.PageTitle>
            <div>
                {dataDocs.map((category) => {
                    return category.documents.map((doc) => {
                        const files = dataDocuments.filter((document) => document.id === doc.id);
                        return (
                            <CardDocument
                                id={doc.id}
                                name={doc.label}
                                label={false}
                                files={files}
                                onFileChange={(event) => handleFileChange({ event, id: doc.id, size: doc.size })}
                                onDeleteFile={handleFileDelete}
                                onClickViewFile={(dataFileClicked) => handleShowModal({ ...dataFileClicked })}
                            />
                        );
                    });
                })}
            </div>

            <ButtonSection>
                <ContainerButton>
                    <Button
                        id="backStep"
                        type="secondary"
                        onClick={() => history.push('/dados_beneficiario/preencher_dados_solicitacao_guias')}
                    >
                        Editar Formulário
                    </Button>
                    <Button
                        id="continueStep"
                        type="primary"
                        onClick={handleFowardStep}
                        disabled={disableBtn()}
                        loading={loadingPost}
                    >
                        Finalizar
                    </Button>
                </ContainerButton>
            </ButtonSection>
            <Modal
                title={modalInfo.title}
                modalSize="lg"
                subtitle={modalInfo.content}
                visible={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                {modalInfo.backButton && (
                    <Button type="primary" onClick={() => setShowModal(false)}>
                        Voltar
                    </Button>
                )}
            </Modal>
        </PageContainer>
    );
}

export default Documentos;
